"use client";
import { Footer, Header } from "@/shared";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import styles from "./layout.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";
import { useAuthCheck } from "@/hooks/authentication/authValidator/useAuthCheck";
import { useLocationCheck } from "@/hooks/authentication/authValidator/useLocationCheck";
import { usePathname } from "next/navigation";

export default function SoftLayout({ children }: { children: React.ReactNode }) {
	const { theme }: ContextProps = useGlobalContext();
	const user = useSelector((state: AppState) => state.user);
	const dispatch = useDispatch();
	const pathname = usePathname();

	useLocationCheck();

	return (
		<div className={styles.layout}>
			<div data-theme={theme} className={styles.layout_background}>
				<Header isNavButton />
				<div className={styles.layout_content}>{children}</div>
			</div>
			<Footer type="soft" />
		</div>
	);
}
